var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2717_25706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0952 36.0067L50.0144 36.6189L47.468 32.1231C49.5898 30.2407 51.1285 27.7861 51.9032 24.9873C52.9622 21.1612 52.4683 17.1521 50.5122 13.6986C49.1958 11.3745 47.343 9.54121 45.1967 8.26491V0H39.0646V1.75782H43.4388V7.37194C39.3177 5.6092 34.4496 5.71713 30.2573 8.09159C23.1272 12.1301 20.6119 21.2166 24.6503 28.3471C27.3823 33.1703 32.4228 35.8813 37.6063 35.8813C39.0811 35.8813 40.5676 35.6597 42.0158 35.2067L43.439 37.7192V58.2423H8.92441V51.6315H2.31348V48.0304H0.555664V52.8745L7.68163 60.0001H45.1967V43.3431L51.8324 55.0592L55.1813 55.9858L58.5175 54.0967L59.4445 50.7478L51.0952 36.0067ZM7.16659 56.9992L3.55638 53.3892H7.16659V56.9992ZM26.1798 27.4807C22.619 21.1937 24.8368 13.1819 31.1236 9.62101C37.4102 6.06002 45.4219 8.27804 48.9828 14.5649C50.7074 17.6098 51.143 21.1447 50.209 24.5184C49.2752 27.892 47.084 30.6997 44.039 32.4243C37.7523 35.9851 29.7407 33.7675 26.1798 27.4807ZM44.9052 33.9538C45.3069 33.7262 45.6949 33.4814 46.0698 33.2216L48.4847 37.4854L46.0936 38.8397L43.6779 34.5749C44.0924 34.3882 44.5022 34.1821 44.9052 33.9538ZM57.0176 52.9259L54.9486 54.0976L53.003 53.5592L45.8792 40.9814L50.4321 38.4025L57.5562 50.9805L57.0176 52.9259Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5266 15.3897C46.022 12.7333 43.573 10.8217 40.6305 10.0073C37.688 9.19268 34.6046 9.57284 31.9481 11.0774C26.4642 14.1835 24.5297 21.1719 27.6356 26.656C29.1403 29.3126 31.5894 31.2242 34.5319 32.0386C35.5453 32.3192 36.575 32.458 37.5987 32.4579C39.5473 32.4578 41.4728 31.9547 43.2143 30.9682C48.6981 27.8622 50.6325 20.8737 47.5266 15.3897ZM42.3479 29.4387C40.0999 30.7121 37.4907 31.0337 35.0009 30.3446C32.511 29.6554 30.4384 28.0377 29.1652 25.7897C26.5368 21.149 28.1739 15.2353 32.8145 12.6069C34.2884 11.7721 35.9174 11.3465 37.5663 11.3465C38.4325 11.3465 39.3042 11.4639 40.1616 11.7013C42.6514 12.3905 44.7239 14.008 45.997 16.256C48.6254 20.8965 46.9884 26.8104 42.3479 29.4387Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1174 41.1992H4.84375V49.4196H10.1174V41.1992ZM8.35961 47.6618H6.60156V42.957H8.35961V47.6618Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1484 49.4198V37.0449H11.875V49.4198H17.1484ZM13.6328 38.8027H15.3906V47.662H13.6328V38.8027Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9053 49.4192H24.1787V34.7363H18.9053V49.4192ZM20.6631 36.4941H22.4209V47.6614H20.6631V36.4941Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31348 1.75782H37.3067V0H0.555664V46.2725H2.31348V1.75782Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4678 17.1218C43.6992 15.7647 42.5594 14.6751 41.1716 13.9707L40.376 15.5381C41.4546 16.0856 42.3406 16.9327 42.9383 17.9879C43.0043 18.1045 43.0672 18.2243 43.125 18.3438L44.7072 17.5779C44.6329 17.4246 44.5524 17.2712 44.4678 17.1218Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6152 19.798C43.7613 20.5194 43.776 21.2561 43.6591 21.9877L45.395 22.2652C45.5452 21.3252 45.5261 20.3777 45.3381 19.4492L43.6152 19.798Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8291 7.91016V5.27344H10.2236H11.9814H13.7393H16.4778V3.51562H13.7393H11.9814H10.2236H4.07129V7.91016V8.43609H5.8291V7.91016Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07129 10.1934H5.8291V11.9512H4.07129V10.1934Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6104 49.7695L54.1396 48.9047L55.0032 50.4317L53.4739 51.2966L52.6104 49.7695Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.043 43.4336L50.5723 42.567L53.3207 47.4171L51.7914 48.2837L49.043 43.4336Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6855 47.6621H32.4435V49.4199H30.6855V47.6621Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 47.6621H28.9279V49.4199H27.1699V47.6621Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2021 47.6621H40.0298V49.4199H34.2021V47.6621Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 43.7715H40.0294V45.5293H27.1699V43.7715Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 39.8809H32.8676V41.6387H27.1699V39.8809Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.626 39.8809H40.0298V41.6387H34.626V39.8809Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6517 24.89H17.7077V10.1402H15.9498V24.89H14.0057V15.7455H12.2479V24.89H10.3036V20.4605H8.54582V24.89H6.60156V22.5046H4.84375V26.6478H21.4095V7.83203H19.6517V24.89Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2157 56.4844H33.7705V54.7266H33.2157H32.0127H31.458V56.4844H32.0127H33.2157Z",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6815 56.4836V52.968V52.9668H39.9237V52.968V54.7258H35.5291H34.9746V56.4836H35.5291H41.6815Z",
    fill: "#201547"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_25706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentsBlue);
export default __webpack_public_path__ + "static/media/assessments-blue.788abd0c55ad2c376e766b84880786c0.svg";
export { ForwardRef as ReactComponent };